(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-preorder-status"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('preorder-status')) {
    class PreorderStatus extends HTMLElement {
      connectedCallback() {
        this.sync();
        this.subscribe();
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      subscribe() {
        const pubsub = window.theme && window.theme.pubsub;
        if (!pubsub) {
          window.addEventListener('DOMContentLoaded', () => this.subscribe(), { once: true });
          return;
        }
        if (this.unsubscribe) return;
        this.unsubscribe = pubsub.subscribe(pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const data = event && event.data ? event.data : {};
          if (data.sectionId && String(data.sectionId) !== this.dataset.sectionId) return;
          const source = data.parsedHTML && data.parsedHTML.getElementById(this.id);
          if (source) {
            this.innerHTML = source.innerHTML;
            this.dataset.preorder = source.dataset.preorder;
          }
          this.sync();
        });
      }

      get isPreorder() {
        return this.dataset.preorder === 'true';
      }

      sync() {
        const on = this.isPreorder;
        const info = this.closest('product-info');
        if (info) info.classList.toggle('is-preorder', on);
        const section = this.closest('.section');
        if (section) section.classList.toggle('is-preorder', on);

        const formId = this.getAttribute('form');
        if (!formId) return;
        const strings = (window.theme && window.theme.variantStrings) || {};
        document.querySelectorAll(`button[name="add"][form="${formId}"]`).forEach((button) => {
          if (on) button.setAttribute('data-pre-order', '');
          else button.removeAttribute('data-pre-order');
          if (button.disabled) return;
          const label = button.querySelector('.btn-text > span:not([role])') || button.querySelector('.btn-text > span');
          const text = on ? strings.preOrder : strings.addToCart;
          if (label && text) label.textContent = text;
        });
      }
    }
    customElements.define('preorder-status', PreorderStatus);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-theme"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-theme')) {
    class VariantTheme extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.section');
        if (!this.section) return;
        this.section.classList.add('vt-scope');
        const own = getComputedStyle(this);
        ['--vt-bg', '--vt-fg'].forEach((name) => {
          const value = own.getPropertyValue(name).trim();
          if (value) this.section.style.setProperty(name, value);
        });
        this.foreground = own.getPropertyValue('--vt-fg').trim();
        this.active = this.dataset.active === 'true';
        this.commit(this.active);
        this.baseBackground = getComputedStyle(document.body).backgroundColor;

        this.onVariantChange = (event) => {
          const variant = event.detail && event.detail.variant;
          if (!variant) return;
          this.apply(this.matches(variant));
        };
        const form = document.forms[this.getAttribute('form')];
        this.target = form || document;
        this.target.addEventListener('variant:change', this.onVariantChange);
      }

      disconnectedCallback() {
        clearTimeout(this.foregroundTimer);
        clearTimeout(this.settleTimer);
        if (this.target) this.target.removeEventListener('variant:change', this.onVariantChange);
      }

      commit(on) {
        this.commitForeground(on);
        this.commitBackground(on);
      }

      commitForeground(on) {
        this.section.classList.toggle('vt-fg', on);
        if (!this.foreground) return;
        if (on) this.section.style.setProperty('--color-foreground', this.foreground);
        else this.section.style.removeProperty('--color-foreground');
      }

      commitBackground(on) {
        this.section.classList.toggle('vt-active', on);
      }

      /*
       * Fraction of the section covered by a circle of radius r, sampled row by row. Exact in x
       * (analytic chord), discretised in y. The naive assumption -- that coverage tracks the
       * radius -- is badly wrong here: the radius runs to the far corner (1234px on desktop) but
       * the section is 99% covered at r=1146. Driving the ramp off radius spends more than half
       * the animation crawling through pixels nobody can see.
       */
      coverageTable(x, y, band, maxRadius, steps, rows) {
        const table = new Float64Array(steps + 1);
        const height = band.bottom - band.top;
        const width = band.right - band.left;
        const dy = height / rows;
        const total = width * height;
        if (total <= 0) return table;
        for (let s = 1; s <= steps; s += 1) {
          const r = (maxRadius * s) / steps;
          const r2 = r * r;
          let area = 0;
          for (let j = 0; j < rows; j += 1) {
            const d = band.top + (j + 0.5) * dy - y;
            const k = r2 - d * d;
            if (k <= 0) continue;
            const half = Math.sqrt(k);
            const left = Math.max(band.left, x - half);
            const right = Math.min(band.right, x + half);
            if (right > left) area += (right - left) * dy;
          }
          table[s] = area / total;
        }
        return table;
      }

      /*
       * The band the shopper can actually see: the section clipped to the viewport. The section
       * runs far taller than the screen (1406px against ~820px of viewport on desktop, worse on
       * mobile), so pacing the ramp across the whole section spends a chunk of it below the fold.
       * Falls back to the whole section if it is scrolled out of view.
       */
      visibleBand(rect) {
        const top = Math.max(0, -rect.top);
        const bottom = Math.min(rect.height, (window.innerHeight || rect.height) - rect.top);
        const left = Math.max(0, -rect.left);
        const right = Math.min(rect.width, (window.innerWidth || rect.width) - rect.left);
        if (bottom - top < 40 || right - left < 40) {
          return { top: 0, bottom: rect.height, left: 0, right: rect.width };
        }
        return { top, bottom, left, right };
      }

      radiusForCoverage(table, maxRadius, target) {
        const n = table.length - 1;
        for (let s = 1; s <= n; s += 1) {
          if (table[s] >= target) {
            const a = table[s - 1];
            const b = table[s];
            const f = b > a ? (target - a) / (b - a) : 0;
            return (maxRadius * (s - 1 + f)) / n;
          }
        }
        return maxRadius;
      }

      /*
       * Speed ramp: coverage follows e(t) = t + A*sin(2*PI*t)/(2*PI), so the sweep runs at
       * (1+A)x speed at both ends and (1-A)x through the middle -- fast, slow, fast. The curve
       * is smooth everywhere (no corners to read as a stutter) and monotonic while A < 1.
       * Emitted as dense keyframes with linear interpolation so the shape is carried by the
       * samples rather than by a single cubic-bezier, which cannot express a mid-animation hold.
       */
      wipeFrames(x, y, maxRadius, table, steps) {
        const A = 0.55;
        const frames = [];
        for (let i = 0; i <= steps; i += 1) {
          const t = i / steps;
          const eased = t + (A * Math.sin(2 * Math.PI * t)) / (2 * Math.PI);
          const target = Math.min(1, Math.max(0, eased));
          const r = i === steps ? maxRadius : this.radiusForCoverage(table, maxRadius, target);
          frames.push({ clipPath: `circle(${r.toFixed(1)}px at ${x}px ${y}px)`, offset: t });
        }
        return frames;
      }

      handleize(value) {
        return String(value || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      }

      matches(variant) {
        const wanted = this.dataset.value;
        const optionValues = [variant.option1, variant.option2, variant.option3].filter(Boolean);
        return optionValues.some((value) => this.handleize(value) === wanted);
      }

      /*
       * The swatch button the shopper just picked, measured live. Anchoring to raw pointer
       * coordinates (the previous behaviour) read as random: a pointerdown anywhere in the
       * section counted, so a tap on a gallery image or the quantity stepper became the origin,
       * and even a real hit on the button used whichever pixel was struck. Coordinates were also
       * captured before the variant change and converted after it, so a gallery swap that shifted
       * layout dragged the origin off the button.
       */
      swatchLabel(value) {
        const picker = this.section.querySelector('variant-picker');
        if (!picker) return null;
        const group =
          picker.querySelector(`[data-option-slug="${this.dataset.option}"]`) ||
          picker.querySelector('fieldset') ||
          picker;
        const inputs = Array.from(group.querySelectorAll('input[data-option-value]'));
        if (!inputs.length) return null;
        let input = null;
        if (value) input = inputs.find((node) => this.handleize(node.dataset.optionValue) === value);
        if (!input) input = inputs.find((node) => node.checked);
        if (!input || !input.id) return null;
        return group.querySelector(`label[for="${input.id}"]`);
      }

      origin(value) {
        const rect = this.section.getBoundingClientRect();
        const label = this.swatchLabel(value);
        if (label) {
          const box = label.getBoundingClientRect();
          if (box.width > 0 && box.height > 0) {
            return {
              x: box.left + box.width / 2 - rect.left,
              y: box.top + box.height / 2 - rect.top,
              rect,
            };
          }
        }
        return { x: rect.width / 2, y: rect.height / 2, rect };
      }

      apply(on) {
        if (on === this.active) return;
        this.active = on;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const duration = parseInt(this.dataset.duration, 10) || 950;
        if (reduce || !this.section.animate) {
          clearTimeout(this.foregroundTimer);
          clearTimeout(this.settleTimer);
          this.section.classList.remove('vt-anim');
          this.commit(on);
          return;
        }

        const { x, y, rect } = this.origin(on ? this.dataset.value : null);
        const radius = Math.hypot(Math.max(x, rect.width - x), Math.max(y, rect.height - y)) + 20;

        const overlay = document.createElement('div');
        overlay.className = 'vt-overlay';
        overlay.style.backgroundColor = on ? `rgb(${getComputedStyle(this).getPropertyValue('--vt-bg')})` : this.baseBackground;
        overlay.style.clipPath = `circle(0px at ${x}px ${y}px)`;
        this.section.prepend(overlay);

        if (this.animation) this.animation.cancel();
        clearTimeout(this.foregroundTimer);
        clearTimeout(this.settleTimer);
        this.section.querySelectorAll('.vt-overlay').forEach((node) => { if (node !== overlay) node.remove(); });

        const table = this.coverageTable(x, y, this.visibleBand(rect), radius, 96, 96);
        const frames = this.wipeFrames(x, y, radius, table, 32);

        // Foreground crosses over while the sweep is still travelling, so the content is already
        // wearing the new palette by the time the wipe lands. Without this it hard-cuts, because
        // the overlay paints behind the content and never masks it.
        const fade = Math.round(duration * 0.45);
        this.section.style.setProperty('--vt-fade', `${fade}ms`);
        this.section.classList.add('vt-anim');
        this.foregroundTimer = setTimeout(() => this.commitForeground(on), Math.round(duration * 0.34));

        const settle = () => {
          this.commitBackground(on);
          this.commitForeground(on);
          overlay.remove();
          this.settleTimer = setTimeout(() => {
            this.section.classList.remove('vt-anim');
            this.section.style.removeProperty('--vt-fade');
          }, fade);
        };

        this.animation = overlay.animate(frames, { duration, easing: 'linear', fill: 'forwards' });
        this.animation.finished.then(settle).catch(settle);
      }
    }
    customElements.define('variant-theme', VariantTheme);
  }

  /*
   * Kaching syncs its per-item dropdowns with the main variant picker in both directions: picking
   * a colour for item #2 clicks the main picker (which re-rendered the page and ran the colour
   * wipe), and a main-picker change is answered by Kaching clicking it back to its item #1.
   * Only a shopper's own tap or key press on the main picker may switch the page: each trusted
   * gesture arms exactly one change; any other change is swallowed and the previous selection
   * restored. Kaching keeps its own per-item variants for the cart either way.
   */
  if (!window.__vtKachingGuard) {
    window.__vtKachingGuard = true;
    let armedAt = 0;
    const lastChecked = new Map();
    const inPicker = (node) => node instanceof Element && node.closest('variant-picker');
    const remember = () => {
      document.querySelectorAll('variant-picker input[type="radio"]:checked').forEach((input) => lastChecked.set(input.name, input.value));
    };
    ['pointerdown', 'keydown'].forEach((type) => {
      document.addEventListener(type, (event) => {
        if (event.isTrusted && inPicker(event.target)) armedAt = Date.now();
      }, true);
    });
    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!inPicker(input) || input.type !== 'radio') return;
      if (Date.now() - armedAt < 1500) {
        armedAt = 0;
        lastChecked.set(input.name, input.value);
        return;
      }
      event.stopImmediatePropagation();
      const value = lastChecked.get(input.name);
      const previous = value != null && Array.from(document.getElementsByName(input.name)).find((node) => node.value === value);
      if (previous && previous !== input) previous.checked = true;
    }, true);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', remember);
    else remember();
    document.addEventListener('variant:change', () => setTimeout(remember, 0), true);
  }
  } catch(e) { console.error(e); }
})();

})();
